import { IClonable } from "../system/IClonable";

export class HelpFileInformation implements IClonable<HelpFileInformation> {
  constructor(public id: number, public windowName: string, public name: string, public contents: string, public terminalName: string, public professionCode: string) {
  }

  clone() {
    return new HelpFileInformation(
      this.id,
      this.windowName,
      this.name,
      this.contents,
      this.terminalName,
      this.professionCode
    );
  }
}
